import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { ButtonActionEmphasis, sanitize, TextField } from '@honeycomb-npm/honeycomb-react';
import { useSelector, useDispatch } from 'react-redux';
import { content } from '../../utils/contentUtils';
import { actionCreators, State } from '../../redux';
import SuccessPage from '../SuccessPage/SuccessPage';
import Loader from '../Shared/Loader/Loader';
import ErrorPage from '../ErrorPage/ErrorPage';
import { customerEmail } from '../../utils/customerEmailUtils';

const UnsubscribeByEmailPage = () => {
  const dispatch = useDispatch();

  const { allCustomersEmailPreference, callToAction: callToActionContent, emailContent } = content;

  let userData = customerEmail;

  const { submitEmailPreferenceForm } = bindActionCreators(actionCreators, dispatch);

  const appContent = allCustomersEmailPreference;
  const emailConstant = {
    email: 'Email',
    confirmEmail: 'ConfirmEmail',
  };

  const initialEmailInfo = {
    errorMessage: '',
    type: 'email',
    valid: true,
    value: '',
  };

  const initialConfirmEmailInfo = {
    errorMessage: '',
    type: 'confirmEmail',
    valid: true,
    value: '',
  };

  const [email, setEmail] = useState(initialEmailInfo);
  const [confirmEmail, setConfirmEmail] = useState(initialConfirmEmailInfo);

  const {
    isLoading,
    isFormVisible,
    isSuccess,
    isFailure,
  } = useSelector((state: State) => state.mainReducer);

  function isValidEmail(emailVal: string) {
    return /^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/.test(emailVal);
  }

  const validateEmail = (_e:string, v: string, type: string) => {
    let errorMessage = '';
    let valid = true;
    const value = v;
    if (!v) {
      errorMessage = emailContent.emailError;
    } else if (v.length > Number(80)) {
      errorMessage = emailContent.invalidEmailError;
    } else if (!isValidEmail(v)) {
      errorMessage = emailContent.invalidEmailError;
    } else if (errorMessage.length === 0 && v.length > 0 && type === emailConstant.confirmEmail && email.value !== v) {
      errorMessage = emailContent.invalidMatch;
    }
    if ((type === emailConstant.confirmEmail && v) || (type === emailConstant.email && v) || errorMessage !== '') {
      valid = (errorMessage.length === 0 && v.length > 0);
    }
    if (confirmEmail.value === v) {
      errorMessage = '';
      valid = true;
      const emailType = emailConstant.confirmEmail;
      setConfirmEmail((prevState) => ({
        ...prevState,
        errorMessage,
        valid,
        value,
      }));
    }
    if (type === emailConstant.email) {
      setEmail({
        errorMessage,
        type,
        valid,
        value,
      });
    } else {
      setConfirmEmail({
        errorMessage,
        type,
        valid,
        value,
      });
    }
    return valid;
  };

  const formSubmit = () => {
    let errorMessage = '';
    let valid = true;
    let value = '';
    let type = '';
    if (email.value !== '' && confirmEmail.value !== '' && email.valid && confirmEmail.valid && email.value === confirmEmail.value) {
      userData = { ...userData, unsubscribeIdentifier: email.value };
      submitEmailPreferenceForm(userData);
    } else {
      if (email.valid && confirmEmail.valid && email.value !== confirmEmail.value) {
        errorMessage = emailContent.invalidMatch;
        valid = false;
        value = confirmEmail.value;
        type = 'ConfirmEmail';
        setConfirmEmail({
          errorMessage,
          type,
          valid,
          value,
        });
      }
      if (email.value === '') {
        errorMessage = emailContent.emailError;
        valid = false;
        value = email.value;
        type = 'Email';
        setEmail({
          errorMessage,
          type,
          valid,
          value,
        });
      }
      if (confirmEmail.value === '') {
        errorMessage = emailContent.confirmEmailError;
        valid = false;
        value = confirmEmail.value;
        type = 'ConfirmEmail';
        setConfirmEmail({
          errorMessage,
          type,
          valid,
          value,
        });
      }
    }
  };

  return (
    <div className="col-12 px-3 px-md-8 px-sm-6 pb-6">
      {isFormVisible && (
        <div className="row mx-0">
          <div className="col-lg-9 col-sm-12 px-0">
            <div className="col-md-5 col-12">
              <div className="mb-5">
                <TextField
                  id="email"
                  type="email"
                  label="Email Address"
                  value={email.value}
                  errormessage={email.errorMessage}
                  isValid={email.valid}
                  maxLength={254}
                  onChange={(e: string, v: string) => {
                    validateEmail(e, v, 'Email');
                  }}
                />
              </div>
              <div className="mb-5">
                <TextField
                  id="confirmemail"
                  type="confirmemail"
                  label="Confirm Email Address"
                  value={confirmEmail.value}
                  errormessage={confirmEmail.errorMessage}
                  isValid={confirmEmail.valid}
                  maxLength={254}
                  onChange={(e: string, v: string) => {
                    validateEmail(e, v, 'ConfirmEmail');
                  }}
                />
              </div>
              <h3>{allCustomersEmailPreference.customersTitle}</h3>
            </div>
            <div className="mt-2" dangerouslySetInnerHTML={sanitize(allCustomersEmailPreference.unsubscribeDesc)} />
            <div className="my-4">
              <ButtonActionEmphasis type="button" disable="true" id="form-submit" onClick={formSubmit}>
                {callToActionContent.unsubscribeBtn.displayText}
              </ButtonActionEmphasis>
            </div>
            <div className="mt-2" style={{ wordBreak: 'break-word' }} dangerouslySetInnerHTML={sanitize(appContent.disclaimerTextForIBM)} />
            <div className="mt-2" style={{ wordBreak: 'break-word' }} dangerouslySetInnerHTML={sanitize(appContent.disclaimerTextMarketingEmails)} />
            <div className="mt-2" style={{ wordBreak: 'break-word' }} dangerouslySetInnerHTML={sanitize(appContent.disclaimerTextForGroupPolicy)} />
          </div>
        </div>
      )}
      {isLoading && <Loader />}
      {isSuccess && <SuccessPage />}
      {isFailure && <ErrorPage />}
    </div>
  );
};
export default UnsubscribeByEmailPage;
